<template>
    <section id="search-query-control" class="section p-0" :class="`${searchControlMarginTop}`">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 px-0">
            <div class="d-flex flex-column justify-content-start align-items-center w-100">
              <div :style="{ minHeight: searchControlHeight, width: '100%', }" class="search-filter-query d-flex flex-xl-row flex-lg-row flex-md-column flex-sm-column flex-column justify-content-center align-items-center">
                <div class="search-filter-query-text-input" :class="searchQueryFilterInputTextClass">
                    <div :style="{ 'right': searchIconPositionStyle }" class="search-icon-position">
                        <font-awesome-icon
                            size="1x"
                            icon="search"
                        />
                    </div>
                  <input 
                      class="search-query-input-text" 
                      type="text" 
                      :placeholder="inputTextPlaceholder" 
                      v-model="searchQuery"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
</template>

<script>
    import { EventBus } from '../../../utils/eventBus';
    export default {
        props: {
            inputTextPlaceholder: {
                default: "input text placeholder",
                type: String,
            },
            searchControlHeight: {
                default: '248px',
                type: String,
            },
            searchQueryInputHandler: {
                default: () => {},
                type: Function,
            },
            searchControlMarginTop: {
                default: 'mt-0',
                type: String,
            },
        },
        data() {
            return {
                searchQuery: "",
            };
        },
        computed: {
            searchQueryFilterInputTextClass(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? 'search-filter-query-text-input-sm-xs' : 'search-filter-query-text-input-md-lg-xl';
            },
            searchIconPositionStyle(){
                return (this.$vuetify.breakpoint.xs || this.$vuetify.breakpoint.sm) ? "2.8%" : "2.6%";
            },
        },
        watch: {
            searchQuery(newValue) {
                this.searchQueryInputHandler(newValue);
            },
        },
        created() {
            EventBus.$on("update-search-query", (query) => this.searchQuery = query ?? "");
        },
        beforeDestroy() {
            EventBus.$off("update-search-query");
        },
    }
</script>

<style scoped>
    .search-icon-position {
        background-color: #ffffff; 
        position: absolute; 
        top: 2px; 
        width: 30px; 
        height: 90%; 
        border-top-right-radius: 10px; 
        border-bottom-right-radius: 10px; 
        display: flex; 
        justify-content: center; 
        align-items: center;
    }
    .search-filter-query {
        min-width: 315px;
        border-radius: 10px;
        background-color: #D5D7D7;
        /* margin-top: 20px; */
        padding: 20px;
    }
    .search-filter-query-text-input {
        width: 90%;
        min-width: 290px;
        height: auto;
        display: flex;
        flex-direction: column;
        align-items: center;
        position: relative;
    }
    .search-filter-query-text-input-md-lg-xl {
        justify-content: center;
    }
    .search-filter-query-text-input-sm-xs {
        justify-content: flex-start;
    }
    .search-query-input-text {
        background-color: #ffffff;
        width: 95%;
        height: 50px;
        border-radius: 10px;
        padding-left: 5px;
        border: 1px solid #000000;
    }
</style>